import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./tabNavigation.css";

const TabNavigation = ({
  tabs,
  activeTab,
  onTabClick,
  className = "",
  slidingIndicator,
}) => {
  const navRef = useRef(null);
  const btnRefs = useRef({});
  const [indicator, setIndicator] = useState({
    left: 0,
    width: 0,
    ready: false,
  });

  const enableSlide =
    slidingIndicator ?? String(className).includes("segment-tabs");

  const updateIndicator = () => {
    const nav = navRef.current;
    const btn = btnRefs.current[activeTab];
    if (!nav || !btn) return;

    const navRect = nav.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    setIndicator({
      left: btnRect.left - navRect.left,
      width: btnRect.width,
      ready: true,
    });
  };

  useLayoutEffect(() => {
    if (!enableSlide) return undefined;
    updateIndicator();
    return undefined;
  }, [activeTab, tabs, enableSlide, className]);

  useEffect(() => {
    if (!enableSlide) return undefined;

    const onResize = () => updateIndicator();
    window.addEventListener("resize", onResize);

    const nav = navRef.current;
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined" && nav) {
      resizeObserver = new ResizeObserver(() => updateIndicator());
      resizeObserver.observe(nav);
    }

    return () => {
      window.removeEventListener("resize", onResize);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [activeTab, tabs, enableSlide]);

  return (
    <div
      ref={navRef}
      className={`tab-navigation ${className}${
        enableSlide ? " has-sliding-indicator" : ""
      }`}
    >
      {enableSlide && (
        <span
          className={`tab-indicator${indicator.ready ? " is-ready" : ""}`}
          aria-hidden="true"
          style={{
            width: `${indicator.width}px`,
            transform: `translateX(${indicator.left}px)`,
          }}
        />
      )}
      {tabs.map((tab) => (
        <button
          key={tab.id}
          ref={(el) => {
            if (el) btnRefs.current[tab.id] = el;
            else delete btnRefs.current[tab.id];
          }}
          type="button"
          className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onTabClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
